module.exports = __webpack_public_path__ + "img/top_back_buttons_quantity.b5dae71b.png";